module.exports = __webpack_public_path__ + "img/3.4b9c27a5.png";